import React from 'react'

const ImageHeader = () => {
    return (
        <header className="header">
            <div className="overlay">
                <p className='text_header'>Una alianza para vivir <span className='span_header'>con plenitud y propósito</span></p>
            </div>
            <img
                src='./assets/logo_mas.webp'
                alt='Soy+'
                className= 'logo_soy'
            />
        </header>
    );
}

export default ImageHeader